import store from '@/store/vuex.js';
export class DefaultService {
    constructor(http, router) {
        this._http = http;
        this._env = process.env.VUE_APP_API_URL;
        this._router = router;
        this._headers = {
            headers: {
                Authorization: $cookies.get('token'),
                'X-App-version-id': $cookies.get('version'),
                'Content-Type': 'application/json',
                responseType: 'arraybuffer',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, HEAD, OPTIONS',
            },
        };
    }

    verifyError(err) {
        console.error(`verifyError: Status ${err.status}`);
        console.info('Erro completo', err);

        if ([401].indexOf(err.status) > -1) {
            store.dispatch('authenticated', { value: false });
        }
    }

    handleError(err) {
        this.verifyError(err);
        throw err;
    }
}
